import React from 'react';

import PageWrapper from 'Dashboard/components/PageWrapper/PageWrapper';
import StyledTitle from 'Shared/components/StyledTitle/StyledTitle';

function ChromeExtensionUninstall() {
  return (
    <PageWrapper>
      <div className="w-100 d-flex align-items-center justify-content-center">
        <div className="d-flex flex-column bg-white rounded p-4">
          <StyledTitle>We&#39;re sad to see you go 😢</StyledTitle>
        </div>
      </div>
    </PageWrapper>
  );
}

export default ChromeExtensionUninstall;
